"use strict";
// @ts-ignore
try {
    self['workbox:expiration:7.0.0'] && _();
}
catch (e) { }
